import { Component, Host, Prop, Watch, h } from '@stencil/core';
import type { IframeByStore } from '../../helpers/utils/iframe-types';

@Component({
  tag: 'cms-iframe',
  styleUrl: 'cms-iframe.scss',
  shadow: true,
})
export class CmsIframe {
  private readonly protocol = 'https://';
  private iframeByStoreData: IframeByStore[] | string;

  /**
   * set the usercentrics consent status
   */
  @Prop({ reflect: true }) isConsent: boolean;

  /**
   * set the iframe target url
   */
  @Prop() iframeUrl: string;

  /**
   * set the control url for using in allow attribute
   */
  @Prop() controlUrl: string;

  /**
   * control the iframe window scrolling like yes, no, auto
   */
  @Prop() scrolling: string;

  /**
   * set the iframe allow parameters
   */
  @Prop() allow: string;

  /**
   * additional javascript code
   */
  @Prop() additionalJsCode: string;

  /**
   * set the accessible name
   */
  @Prop() accessibleName: string;

  /**
   * set the iframe type
   */
  @Prop() type: 'default' | 'store' = 'default';

  /**
   * set the iframe by store
   */
  @Prop() iframeByStore: IframeByStore[] | string;

  @Watch('iframeByStore')
  private iframeByStoreWatcher(newValue: string | IframeByStore[]) {
    if (newValue) {
      this.iframeByStoreData =
        typeof newValue === 'string' ? JSON.parse(newValue) : newValue;
    }
  }
  private buildParams() {
    return `${this.allow || ''} ${
      this.controlUrl ? `${this.protocol}${this.controlUrl}` : ''
    }`;
  }

  private buildUrl(url: string) {
    if (url) {
      return `${this.protocol}${url}`;
    }
  }

  private getCurrentStore() {
    const hbDataLayer = window.hbDataLayer;
    if (hbDataLayer?.['site.market']) {
      return hbDataLayer['site.market'];
    }
  }

  private mapStore() {
    if (Array.isArray(this.iframeByStoreData)) {
      return this.iframeByStoreData.find(
        (store) => store.storeId === this.getCurrentStore(),
      );
    }
  }

  private renderIframe(iframeUrl: string) {
    return [
      <iframe
        key={'iframe'}
        title={iframeUrl}
        loading='lazy'
        class={'iframe-node'}
        src={iframeUrl}
        scrolling={this.scrolling ? this.scrolling : null}
        allow={this.allow ? this.buildParams() : null}
        style={{ border: '0' }}
      />,
      this.additionalJsCode ? (
        <script key={'script'} innerHTML={this.additionalJsCode} />
      ) : null,
    ];
  }

  private iframeControl() {
    if (this.type === 'store') {
      const storeData = this.mapStore();
      if (!storeData) {
        return;
      }
      const iframeUrl = this.buildUrl(storeData.iframeUrl);
      return this.renderIframe(iframeUrl);
    }

    if (this.type === 'default' && this.iframeUrl) {
      const iframeUrl = this.buildUrl(this.iframeUrl);
      return this.renderIframe(iframeUrl);
    }

    return;
  }

  connectedCallback() {
    if (this.iframeByStore && this.type === 'store') {
      this.iframeByStoreWatcher(this.iframeByStore);
    }
  }

  render() {
    return (
      <Host>
        <section class={'host-inner'} aria-label={this.accessibleName}>
          {this.isConsent ? (
            this.iframeControl()
          ) : (
            <div class='consent-container'>
              <slot name='hdp-consent' />
            </div>
          )}
        </section>
      </Host>
    );
  }
}
